import UserEntity from "../../../../../domain/entities/UserEntity";

//TODO implement
const GetEmployeeByIdApiImpl = async (id: string): Promise<UserEntity | undefined> => {
    throw new Error("Method not implemented.");
}

export default GetEmployeeByIdApiImpl;